import React from 'react';
import { motion } from 'framer-motion';
import { Clock, TrendingUp } from 'lucide-react';

/**
 * Level History Timeline Component
 * Shows history of level upgrades
 */
const LevelHistory = ({ history }) => {
  if (!history || history.length === 0) {
    return (
      <div className="bg-gray-50 rounded-xl p-6 text-center">
        <Clock className="mx-auto mb-2 text-gray-400" size={32} />
        <p className="text-gray-500">Aucun historique de niveau pour le moment</p>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-4"
    >
      <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        <Clock size={24} />
        Historique des Niveaux
      </h3>

      <div className="relative">
        {/* Timeline line */}
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-amber-400 via-purple-400 to-pink-400" />

        {/* Timeline items */}
        <div className="space-y-6">
          {history.map((item, index) => {
            const date = new Date(item.timestamp);
            const formattedDate = date.toLocaleDateString('fr-FR', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            });

            return (
              <motion.div
                key={item.id || index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="relative pl-16"
              >
                {/* Timeline dot */}
                <div className="absolute left-4 top-2 w-5 h-5 rounded-full bg-gradient-to-br from-amber-400 to-purple-600 border-4 border-white shadow-lg" />

                {/* Card */}
                <div className="bg-white rounded-lg p-4 shadow-md border border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <TrendingUp className="text-green-600" size={20} />
                      <span className="font-bold text-gray-800">
                        {item.old_level_name || 'Aucun'} → {item.new_level_name}
                      </span>
                    </div>
                    <span className="text-xs text-gray-500">{formattedDate}</span>
                  </div>
                  <p className="text-sm text-gray-600">
                    Commission : <span className="font-semibold text-purple-600">
                      {item.old_commission_rate || 0}%
                    </span> → <span className="font-semibold text-green-600">
                      {item.new_commission_rate}%
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {item.paid_referrals_count} filleul{item.paid_referrals_count > 1 ? 's' : ''} payant{item.paid_referrals_count > 1 ? 's' : ''}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default LevelHistory;
